module.exports = __webpack_public_path__ + "assets/img/analysisOverview.70eb4681.svg";